export const TRIPS = "TRIPS";
export const COUNT_TRIPS = "COUNT_TRIPS";
